// extracted by mini-css-extract-plugin
module.exports = {"list":"AuthorsList_list__NVYKd"};